<div class="my-hr-home">
  <app-page-data-panel
    title="My services"
    subtitle="Start from a focused self-service page instead of a single long workspace.">
    <div class="launcher-grid">
      @for (card of cards; track card.route) {
        <a class="launcher-card" [class]="'launcher-card accent-' + card.accent" [routerLink]="card.route">
          <div class="launcher-card-top">
            <span class="launcher-icon"><i [class]="card.icon"></i></span>
            @if ((card.badge ?? 0) > 0) {
              <p-tag [value]="card.badge + ''" severity="info"></p-tag>
            }
          </div>
          <div class="launcher-card-body">
            <h3>{{ card.title }}</h3>
            <p>{{ card.description }}</p>
          </div>
          <div class="launcher-card-footer">
            <span>Open page</span>
            <i class="fa-solid fa-arrow-right"></i>
          </div>
        </a>
      }
    </div>
  </app-page-data-panel>

  <div class="overview-grid">
    <app-page-data-panel title="Quick actions" subtitle="Common employee actions, without the HR admin complexity.">
      <div class="quick-actions">
        <a class="quick-action" routerLink="/my-hr/leave">
          <i class="fa-solid fa-calendar-plus"></i>
          <div>
            <strong>Request leave</strong>
            <span>Submit time off in a guided form.</span>
          </div>
        </a>
        @if (canViewExpenses || canManageExpenses) {
          <a class="quick-action" routerLink="/my-hr/expenses">
            <i class="fa-solid fa-receipt"></i>
            <div>
              <strong>Add expense</strong>
              <span>Capture a claim in one quick entry form.</span>
            </div>
          </a>
        }
        <a class="quick-action" routerLink="/my-hr/approvals">
          <i class="fa-solid fa-list-check"></i>
          <div>
            <strong>See approvals</strong>
            <span>Track request status and approval queues.</span>
          </div>
        </a>
      </div>
    </app-page-data-panel>

    <app-page-data-panel title="Recent requests" subtitle="Latest employee-facing activity across leave, time, and expenses.">
      <div class="recent-grid">
        <section class="recent-column">
          <header>
            <h4>Leave</h4>
            <a routerLink="/my-hr/leave">Open</a>
          </header>
          @if (overview?.leave?.length) {
            <div class="recent-list">
              @for (request of overview?.leave | slice:0:4; track request.leaveRequestId) {
                <article class="recent-row">
                  <div>
                    <strong>{{ request.leaveName || request.leaveCode || 'Leave request' }}</strong>
                    <span>{{ request.startDate | date:'mediumDate' }} to {{ request.endDate | date:'mediumDate' }}</span>
                  </div>
                  <p-tag [value]="label(request.requestStatus)" [severity]="statusSeverity(request.requestStatus)"></p-tag>
                </article>
              }
            </div>
          } @else {
            <p class="empty-state">No leave requests yet.</p>
          }
        </section>

        <section class="recent-column">
          <header>
            <h4>Timesheets</h4>
            <a routerLink="/my-hr/timesheets">Open</a>
          </header>
          @if (overview?.timesheets?.length) {
            <div class="recent-list">
              @for (timesheet of overview?.timesheets | slice:0:4; track timesheet.timesheetId) {
                <article class="recent-row">
                  <div>
                    <strong>{{ timesheet.periodStart | date:'MMM d' }} - {{ timesheet.periodEnd | date:'MMM d' }}</strong>
                    <span>{{ (timesheet.regularHours || 0) + (timesheet.overtimeHours || 0) }} hours captured</span>
                  </div>
                  <p-tag [value]="label(timesheet.timesheetStatus)" [severity]="statusSeverity(timesheet.timesheetStatus)"></p-tag>
                </article>
              }
            </div>
          } @else {
            <p class="empty-state">No timesheets to review.</p>
          }
        </section>

        <section class="recent-column">
          <header>
            <h4>Expenses</h4>
            @if (canViewExpenses || canManageExpenses) {
              <a routerLink="/my-hr/expenses">Open</a>
            }
          </header>
          @if (overview?.expenses?.length) {
            <div class="recent-list">
              @for (expense of overview?.expenses | slice:0:4; track expense.expenseId) {
                <article class="recent-row">
                  <div>
                    <strong>{{ expense.description || expense.expenseNumber || 'Expense claim' }}</strong>
                    <span>{{ expense.totalAmount | currency:(expense.currencyCode || 'SAR'):'symbol':'1.0-2' }}</span>
                  </div>
                  <p-tag [value]="label(expense.status)" [severity]="statusSeverity(expense.status)"></p-tag>
                </article>
              }
            </div>
          } @else {
            <p class="empty-state">No expense claims yet.</p>
          }
        </section>
      </div>
    </app-page-data-panel>
  </div>
</div>
